import { enUS, es, ptBR } from 'date-fns/locale';

export const LANGUAGES = [
  { order: 1, _iso: 'en', file: 'en.json', name: 'English', flag: 'GB' },
  { order: 2, _iso: 'pt', file: 'pt.json', name: 'Português', flag: 'BR' },
  { order: 3, _iso: 'es', file: 'es.json', name: 'Español', flag: 'ES' },
];

export const LANGUAGES_DATE_FNS = [
  { order: 1, file: enUS },
  { order: 2, file: ptBR },
  { order: 3, file: es },
];

export const DEFAULT_DATE_FNS = enUS;
